const btn = document.querySelector('.arrow-up')

if (btn) {
    window.addEventListener('scroll', function() {
        let scrolled = window.pageYOffset;
        let coords = document.documentElement.clientHeight;
        if (scrolled > coords) {
            btn.classList.add('active');
        }
        if (scrolled < coords) {
            btn.classList.remove('active');
        }
    });
    btn.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    } )
}